import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, ChevronDown } from 'lucide-react';

const SIM_OPTIONS = [
  "NA",
  "Single Physical SIM",
  "Single eSIM",
  "Single Physical SIM + eSIM",
  "Dual Physical SIM",
  "Dual eSIM",
  "Dual Physical SIM, Single Physical SIM",
  "Dual Physical SIM, Single SIM + eSIM",
];

function SimOptionDropdown({ value, onChange, isDevice, error }) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const [dropPos, setDropPos] = useState({ top: 0, left: 0, width: 0 });

  const openDropdown = () => {
    if (!isDevice) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setDropPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
    setIsOpen(true);
  };

  useEffect(() => {
    if (!isOpen) return;
    const close = (e) => {
      if (triggerRef.current && !triggerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [isOpen]);

  if (!isDevice) {
    return (
      <div
        style={{
          minWidth: 200,
          maxWidth: 200,
          border: '1px solid #DEE2E6',
          borderRadius: 8,
          padding: '8px 14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          backgroundColor: '#F8F9FA',
          minHeight: 42,
          cursor: 'not-allowed',
          opacity: 0.6,
          fontfamily: "Montserrat",
        }}
      >
        <ChevronDown size={13} color="#212529D" />
      </div>
    );
  }

  return (
    <div ref={triggerRef} style={{ minWidth: 200, maxWidth: 200 }}>
      <div
        onClick={openDropdown}
        style={{
          border: error ? '1px solid #dc3545' : '1px solid #6C757D',
          borderRadius: 8,
          padding: '8px 14px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          minHeight: 42,
          gap: 6,
        }}
      >
        <span
          style={{
            fontSize: 14,
            color: value ? '#212529' : '#6C757D',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            minWidth: 0,
          }}
        >
          {value || 'Search and Select'}
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
          {value && (
            <span
              onMouseDown={(e) => {
                e.stopPropagation();
                onChange('');
              }}
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              <X size={13} color="#212529" />
            </span>
          )}
          <ChevronDown size={13} color="#212529" />
        </div>
      </div>

      {error && (
        <div className="invalid-feedback d-block" style={{ fontSize: 12, marginTop: 4 }}>
          {error}
        </div>
      )}

      {isOpen &&
        createPortal(
          <div
            style={{
              position: 'fixed',
              top: dropPos.top,
              left: dropPos.left,
              width: dropPos.width,
              background: '#fff',
              border: '1px solid #DEE2E6',
              borderRadius: 8,
              boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
              maxHeight: 220,
              overflowY: 'auto',
              zIndex: 9999,
              padding: '4px 0',
            }}
          >
            {SIM_OPTIONS.map((opt) => (
              <div
                key={opt}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(opt);
                  setIsOpen(false);
                }}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  fontSize: 14,
                  color: '#212529',
                  backgroundColor: value === opt ? '#FFFEF0' : 'transparent',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#FFFEF0';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    value === opt ? '#FFFEF0' : 'transparent';
                }}
              >
                {opt}
              </div>
            ))}
          </div>,
          document.body
        )}
    </div>
  );
}

export default SimOptionDropdown;
